angular.module('$traineePlayer.config', []).value('$traineePlayerConfig', {});

angular.module('service.quiz', ['factories.serviceHelper']);
angular.module('service.survey', ['factories.serviceHelper']);

angular.module('$traineePlayer', [
  'factories.frameStateProgressHelper',
  'services.sension',
  'quiz.quizCtrl',
  'survey.surveyCtrl',
  'directives.verticalTray',
  'newDocument.documentCtrl',
  'boxPreview',
  'contentPlayer.contentPlayerHeaderDirective',
  'contentPlayer.slideViewerDirective',
  'contentPlayer.contentPlayerCtrl',
  'contentPlayer.contentErrorModal',
  'contentPlayer.reuseStateModalCtrl',
  'ppt.pptImageCtrl',
  'media.mediaControlsCtrl',
  'video.videoCtrl',
  'video.youtubeCtrl',
  'quiz.sequence',
  'quiz.labelingItemsInPicture',
  'mfTrainee.directives',
  'mfTrainee.filters',
  'ppt.pptImageDirective',
  'contentPlayer.cModuleIntro',
  'contentPlayer.cModuleOutro',
  'contentPlayer.emailTrainerCtrl',
  'contentPlayer.sendPreviewCtrl',
  'contentPlayer.yammerShareCtrl',
  'service.contentPlayer',
  'service.previewContentPlayer',
  'audio.audioDirective',
  'audio.audioCtrl',
  'scorm.scormCtrl',
  '$traineePlayer.config'
]);
